import axios from "axios";
import MockupAxios from "../utility/mockups/MockupAxios";
import Cookies from "js-cookie";

const MOCKUP = false;
const baseURL = process.env.REACT_APP_SERVER_URL;
let api = MOCKUP ? new MockupAxios() : axios.create({ baseURL });

const attributionParams = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "gclid",
  "fbclid",
] as const;
const attributionStorageKey = (param: typeof attributionParams[number]) => `@aprovaai/${param}`;

const captureAttributionParams = () => {
  if (typeof window === "undefined") return;

  const query = new URLSearchParams(window.location.search);
  attributionParams.forEach((param) => {
    const value = query.get(param);
    if (value) localStorage.setItem(attributionStorageKey(param), value);
  });
};

captureAttributionParams();

api.interceptors.request.use((config) => {
  captureAttributionParams();

  const localUser = localStorage.getItem("@aprovaai/user");
  const localRole = localStorage.getItem("@aprovaai/role");
  const user = localUser ? JSON.parse(localUser) : null;
  const role = localRole ? JSON.parse(localRole) : null;

  const attributionHeaders = Object.fromEntries(
    attributionParams.flatMap((param) => {
      const value = localStorage.getItem(attributionStorageKey(param));
      return value ? [[param, value]] : [];
    })
  );
  const fbp = Cookies.get("_fbp");
  const fbc = Cookies.get("_fbc");
  const ttp = Cookies.get("_ttp");
  const ttclid = Cookies.get("_ttclid");

  if (user && user.token) {
    config.headers = {
      ...config.headers,
      Authorization: `Bearer ${user.token}`,
      Role: role?._id
    };
  }
  config.headers = {
    ...config.headers,
    ...(fbp ? { fbp } : {}),
    ...(fbc ? { fbc } : {}),
    ...(ttp ? { ttp } : {}),
    ...(ttclid ? { ttclid } : {}),
    ...attributionHeaders,
  }

  return config;
});

api.interceptors.response.use((response) => {
  return response;
}, (error) => {
  const {response} = error;
  let message = Array.isArray(response.data?.message) ? response.data?.message.join(", ") : response.data?.message;
  if(message === 'Network Error') message = "Consulta indisponível no momento";
  if(message){ throw new Error(message); }
  throw error;
});

export {api};